/**
 * Calendar service
 */
import { Injectable } from '@angular/core';
import { BaseService } from '../base';
import { IEntityConfig, ENTITY_TYPES } from '@shared/types';

// define config for the current entity
const entityType: ENTITY_TYPES = ENTITY_TYPES.DASHBOARD;
const config: IEntityConfig = {
  ENTITY_TYPE: entityType,
  isMasterListAvailable: true,
  buttons: {},
  apiEndpoint: entityType,
  uiRoute: entityType,
};

/**
 * Home service that extends BaseService to use
 *
 */
@Injectable()
export class HomeService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;
}
